// import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import "./App.css";

import InvitationPage from "./pages/InvitationPage";
import LoginPage from "./pages/LoginPage";
import InfosPratiques from "./pages/InfosPratiques";
import Activites from "./pages/Activites";
import Contribution from "./pages/Contribution";
import Playlist from "./pages/Playlist";
import Photos from "./pages/Photos";
import FAQ from "./pages/FAQ";
import Civil from "./pages/Civil";
import MenuBar from "./pages/MenuBar";
import Boutchou from "./pages/Boutchou";
import Urne from "./pages/Urne";
import Nina from "./pages/Nina";

function Layout() {
  const location = useLocation();
  const hideSidebar = location.pathname === "/";


  // const [choice, setChoice] = useState("");
  // const [details, setDetails] = useState("");
  // const [name, setName] = useState("");
  // const [choicesList, setChoicesList] = useState([]);
  // const [error, setError] = useState("");

  // const isLocal = window.location.hostname === "localhost";
  // const API_URL = isLocal ? "http://localhost:5000" // backend local sans /api 
  //   : "/api"; // backend prod avec /api

  // //  Charger la liste au démarrage
  // useEffect(() => {
  //   const fetchChoices = async () => {
  //     try {
  //       // const response = await fetch("/choices");
  //       const response = await fetch(`${API_URL}/choices`);
  //       if (!response.ok) {
  //         console.error("Erreur lors du chargement des choix");
  //         return;
  //       }
  //       const data = await response.json();
  //       setChoicesList(data);
  //       setError("");
  //     } catch (error) {
  //       setError("Impossible de récupérer la liste (serveur indisponible).");
  //     }
  //   };
  //   fetchChoices();
  //   // fetch("/api/choices")
  //   //   .then((res) => res.json())
  //   //   .then((data) => setChoicesList(data));
  // }, [API_URL]);


  // const handleSubmit = async () => {
  //   if (!choice || !details || !name) {
  //     return alert("Veuillez remplir tous les champs !");
  //   }

  //   try {
  //     // await fetch("/add-choice", {
  //     const response = await fetch(`${API_URL}/add-choice`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ name, choice, details }),
  //     });

  //     if (!response.ok) throw new Error("Serveur indisponible");

  //     // Recharger la liste après ajout
  //     const updatedList = await fetch(`${API_URL}/choices`).then((res) => res.json());
  //     setChoicesList(updatedList);

  //     alert("Votre choix a été enregistré !");
  //     setDetails("");
  //     setName("");
  //     setChoice("");
  //     setError("");
  //   } catch (error) {
  //     setError("Impossible d'enregistrer votre choix (serveur indisponible).");
  //   };
  // };

  return (
    <div style={{ display: "flex" }}>
      {!hideSidebar && <Sidebar />}

      <div className={`content ${hideSidebar ? "no-sidebar" : "with-sidebar"}`}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/invitation" element={<InvitationPage />} />
          <Route path="/menu-bar" element={<MenuBar />} />
          <Route path="/infos" element={<InfosPratiques />} />
          <Route path="/activites" element={<Activites />} />
          <Route path="/boutchou" element={<Boutchou />} />
          <Route path="/contribution" element={<Contribution />} />
          <Route path="/playlist" element={<Playlist />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/civil" element={<Civil />} />
          <Route path="/urne" element={<Urne />} />
          <Route path="/nina" element={<Nina />} />
        </Routes>
      </div>

    </div>
  );

}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  )
}

export default App;
